import React from "react";
import Image from "next/image";
import { Typography } from "../typography";

interface InformationProps {
  description?: React.ReactNode;
  showLoginLink?: boolean;
  loginLinkText?: string;
  prefixText?: string;
  suffixText?: string;
  onLoginClick?: () => void;
  className?: string;
  classDescription?: string;
}

export default function Information({
  description = "",
  showLoginLink = false,
  loginLinkText,
  prefixText,
  suffixText,
  onLoginClick,
  className = "",
  classDescription = "",
}: InformationProps) {
  return (
    <div
      className={`bg-gray-100 px-4 py-4 rounded-xl text-sm text-gray-600 flex items-start gap-3 whitespace-pre-line ${className}`}
    >
      <Image
        width={16}
        height={16}
        src="/images/information-icon.svg"
        alt="Information"
        className="w-4 h-4 mt-1 flex-shrink-0"
      />
      <div className="flex-1">
        <div className="text-sm text-gray-500 font-medium">
          <Typography variant="body3" className={classDescription}>
            {description}
          </Typography>
          {showLoginLink && (
            <Typography
              as="p"
              variant="body3"
              tone="description"
              className="font-medium"
            >
              {prefixText}{" "}
              <button
                type="button"
                className="underline underline-offset-2 cursor-pointer bg-transparent border-0 p-0 font-bold transition-colors text-xs"
                onClick={onLoginClick}
              >
                {loginLinkText}
              </button>{" "}
              {suffixText}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
